export default __webpack_public_path__ + "static/media/Pal_before_2.0321887d.JPG";